import type { RouteRecordRaw } from "vue-router"
import auth from "@/middlewares/auth"
import staffSupport from "@/middlewares/staffSupport"

const supportRoutes: RouteRecordRaw[] = [
  {
    path: "/support",
    name: "support-inbox",
    component: () => import("@/views/support/SupportInboxView.vue"),
    meta: {
      middleware: [auth, staffSupport],
      title: "support.page_title",
    },
  },
  {
    path: "/support/:id",
    name: "support-case",
    component: () => import("@/views/support/SupportCaseView.vue"),
    meta: {
      middleware: [auth, staffSupport],
      title: "support.case_page_title",
    },
  },
]

export default supportRoutes
